export default function Picture({
  src,
  fallback,
  alt,
  className,
  width,
  height,
  loading = "lazy",
  fetchPriority,
  style,
}) {
  return (
    <picture>
      {src ? <source srcSet={src} type="image/webp" /> : null}
      <img
        src={fallback || src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        style={style}
      />
    </picture>
  );
}
